<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddFacility()">Add Facility</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEditFacility()">Edit Facility</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleFacility()">
			{{ ToggleText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstFacility"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedFacility"
		dataKey="FacilityID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FacilityName-->
				<th>
					<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FacilityCD-->
				<th>
					<p-columnFilter type="text" field="FacilityCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AddressDesc-->
				<th>
					<p-columnFilter type="text" field="AddressDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--WorkPhone-->
				<th>
					<p-columnFilter type="text" field="WorkPhone" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DefinedByDesc-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FacilityName">Facility Name<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="FacilityCD">Code<p-sortIcon field="FacilityCD"></p-sortIcon></th>
				<th pSortableColumn="AddressDesc">Address<p-sortIcon field="AddressDesc"></p-sortIcon></th>
				<th pSortableColumn="WorkPhone">Phone<p-sortIcon field="WorkPhone"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Facility>
			<tr [pSelectableRow]="Facility" (dblclick)="onRowDblClick(Facility)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Facility[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
